import React, { useState } from "react";
import {
    MailOutlined,
    CalendarOutlined,
    UserOutlined,
    InfoCircleOutlined,
} from "@ant-design/icons";
import { Col, Row } from "antd";
import CommonCard from "../../../../global/card";
import { cn } from "../../../../../utils/cn";
import { formatDateTime } from "../../../../../utils/functions";

const EnhancedEmailLogDetails = ({
    emailLogDetail,
}) => {
    if (!emailLogDetail) return null;

    const getIconForField = (label) => {
        const iconMap = {
            "Client Email": <UserOutlined />,
            "Email To": <MailOutlined />,
            "Sent At": <CalendarOutlined />,
        };
        return iconMap[label] || <InfoCircleOutlined />;
    };

    return (
        <div className="p-6" style={{ backgroundColor: "#f5f7fa" }}>
            <Row gutter={[24, 24]}>
                {/* Basic Details */}
                <Col span={24}>
                    <CommonCard
                        title={
                            <div className="flex items-center gap-2">
                                <InfoCircleOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "18px" }} />
                                <span style={{ fontSize: "16px", fontWeight: 600 }}>Email Details</span>
                            </div>
                        }
                    >
                        <Row>
                            {[
                                { label: "Client Email", value: emailLogDetail?.userEmail },
                                { label: "Email To", value: emailLogDetail?.emailTo },
                                { label: "Sent At", value: formatDateTime(emailLogDetail?.createdAt) },
                            ].map((item, idx) => (
                                <Col span={24} key={item.label} className={cn("border-b border-gray-200 py-4", idx === 2 && "!border-b-0")}>
                                    <div className="flex justify-between items-center w-full">
                                        <span className="text-sm text-gray-600 flex items-center gap-2 font-medium">
                                            <span style={{ color: "var(--primary-color, #1890ff)", fontSize: "16px" }}>
                                                {getIconForField(item.label)}
                                            </span>
                                            {item.label}
                                        </span>
                                        <span className="text-sm font-semibold text-gray-900">{item.value || "—"}</span>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </CommonCard>
                </Col>

                {/* Message Content */}
                <Col span={24}>
                    <CommonCard
                        title={
                            <div className="flex items-center gap-2">
                                <MailOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "18px" }} />
                                <span style={{ fontSize: "16px", fontWeight: 600 }}>Message Content</span>
                            </div>
                        }
                    >
                        <div
                            className="text-sm text-gray-700 overflow-auto max-h-[500px]"
                            dangerouslySetInnerHTML={{ __html: emailLogDetail?.emailBody }}
                        />
                    </CommonCard>
                </Col>
            </Row>
        </div>
    );
};

export default EnhancedEmailLogDetails;
